import { useId, useState } from 'react';
import { PlusIcon } from './Icons';

export default function Accordion({ items, initialOpen = 0 }) {
  const [openIndex, setOpenIndex] = useState(initialOpen);
  const baseId = useId().replace(/:/g, '');

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const open = openIndex === index;
        const panelId = `${baseId}-panel-${index}`;
        const buttonId = `${baseId}-button-${index}`;
        return (
          <div className="accordion__item" data-open={open || undefined} key={item.question}>
            <h3>
              <button
                id={buttonId}
                type="button"
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => setOpenIndex(open ? -1 : index)}
              >
                <span className="accordion__index">{String(index + 1).padStart(2, '0')}</span>
                <span>{item.question}</span>
                <span className="accordion__icon"><PlusIcon /></span>
              </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={buttonId} className="accordion__panel" inert={!open ? true : undefined}>
              <div><p>{item.answer}</p></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
